import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const ConnectionBadge = ({ size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 145 145">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G transform="translate(-116.000000, -240.000000)">
          <G id="Group-4" transform="translate(119.000000, 243.000000)">
            <Circle
              id="Oval"
              stroke="#FFE66D"
              strokeWidth="6"
              fillOpacity="0.8"
              fill="#4250FB"
              cx="69.5"
              cy="69.5"
              r="69.5"
            />
            <G
              id="bell-(1)"
              transform="translate(36.000000, 27.000000)"
              fillRule="nonzero"
            >
              <Path
                d="M35,75 C35,81.0754683 29.8509485,86 23.5,86 C17.148374,86 12,81.0754683 12,75 C12,68.9251797 17.148374,64 23.5,64 C29.8509485,64 35,68.9251797 35,75 Z"
                id="Path"
                fill="#FF983B"
              ></Path>
              <Path
                d="M56.9863348,38.2209751 C56.9863348,38.2130444 56.9863348,38.2051138 56.9863348,38.1971831 C56.9863348,25.3858614 46.695224,15 34.0002631,15 C21.3046439,15 11.0135331,25.3858614 11.0135331,38.1971831 C10.9404296,47.4998483 7.9945613,56.4535645 1.4850681,64.7615927 C-2.07658096,69.3071831 1.17553121,76 6.91776832,76 L61.0827581,76 C66.8249953,76 70.0764489,69.3071831 66.5147998,64.7615927 C60.007941,56.456869 57.064707,47.5097617 56.9863348,38.2209751 Z"
                id="Path"
                fill="#FFDF65"
              ></Path>
              <Path
                d="M66.5098072,64.7610536 C59.981075,56.4564199 57.0279471,47.5094095 56.9493115,38.2207235 C56.9493115,38.2127929 56.9493115,38.2048624 56.9493115,38.1969318 C56.9493115,25.3857488 46.6236062,15 33.8853095,15 L33.8853095,20.2288924 C43.7055008,20.2288924 51.6965897,28.2645476 51.7210394,38.1519919 L51.7210394,38.2650026 C51.812891,49.0942026 55.4056761,59.0966404 62.4002742,67.992763 C62.9705471,68.7184105 62.759751,69.4361276 62.5833167,69.7989514 C62.4068823,70.162436 61.9747172,70.7711076 61.0588445,70.7711076 L0,70.7711076 C0.75067204,73.6399932 3.29079837,76 6.71243546,76 L61.0595053,76 C66.8210454,75.9993392 70.083429,69.3065947 66.5098072,64.7610536 L66.5098072,64.7610536 Z"
                id="Path"
                fill="#FFB545"
              ></Path>
              <Path
                d="M31.1190648,10 L24.4589898,21.8006263 C23.1547304,24.111459 24.7853759,27 27.3938945,27 L28.9166011,27 C31.7242925,27 34,24.6720791 34,21.8006263 L34,10 L31.1190648,10 Z"
                id="Path"
                fill="#FF5368"
              ></Path>
              <Path
                d="M43.5410102,21.8006263 L36.8802929,10 L34,10 L34,21.8006263 C34,24.6720791 36.2757077,27 39.0833988,27 L40.6061056,27 C43.2146242,27 44.8452695,24.111459 43.5410102,21.8006263 Z"
                id="Path"
                fill="#D43453"
              ></Path>
              <Path
                d="M45.8001701,0.459343833 L33.9999999,7.11929797 L22.1998299,0.459343833 C19.8884292,-0.845534369 17,0.785081554 17,3.39355275 L17,16.606167 C17,19.2146384 19.8884292,20.8452542 22.1998299,19.5410186 L33.9999999,12.8804218 L45.8001701,19.5410186 C48.1109135,20.8452542 51,19.2146384 51,16.606167 C51,12.6632635 51,7.37564778 51,3.39419535 C51,0.785081554 48.1109135,-0.845534369 45.8001701,0.459343833 Z"
                id="Path"
                fill="#FF5368"
              ></Path>
              <G
                id="Group"
                transform="translate(18.000000, 5.000000)"
                fill="#D43453"
              >
                <Path
                  d="M28.8736847,0.645168098 C28.5145886,0.0426715761 27.7187898,-0.163680326 27.0966199,0.184060761 L15.938337,6.42238451 L4.78005421,0.184060761 C4.15788416,-0.164317174 3.36208546,0.0426715761 3.00298956,0.645168098 C2.64389349,1.24766478 2.85698342,2.01766304 3.4791533,2.36604114 L15.2878866,8.96802815 C15.2885444,8.968665 15.2898597,8.96930201 15.291175,8.96993886 C15.3280053,8.99031929 15.3661511,9.00687848 15.4049546,9.0234375 C15.4187659,9.0298063 15.4325773,9.03808598 15.4470464,9.04381793 C15.4654616,9.05082375 15.4845344,9.05528185 15.5029496,9.06165082 C15.6450096,9.1106912 15.7910155,9.13680359 15.9370217,9.13680359 L15.938337,9.13680359 L15.9396524,9.13680359 C16.0850008,9.13680359 16.2323222,9.1106912 16.3743821,9.06165082 C16.3921397,9.05528185 16.4112125,9.05082375 16.4296277,9.04381793 C16.4440968,9.03808598 16.4579082,9.0298063 16.4723773,9.0234375 C16.510523,9.00687848 16.5486686,8.99031929 16.585499,8.96993886 C16.5868144,8.96930201 16.5874721,8.968665 16.5887875,8.96802815 L28.3975206,2.36604114 C29.0196907,2.01766304 29.2327806,1.24766478 28.8736847,0.645168098 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M27.7470703,14.4796621 C30.0594906,15.7725458 32.9506736,14.1561227 32.9506736,11.570355 C32.9506736,8.9654806 32.9506736,5.76957375 32.9506736,2.7577275 C32.9006895,2.7577275 32.8513633,2.7577275 32.8020369,2.75963821 C30.5928731,2.83542799 28.8743424,4.65820304 28.8743424,6.79878571 C28.8743424,8.46679696 27.0058595,9.50683598 25.5162029,8.66932745 C17.005102,3.88247283 17.2576531,3.93087636 15.8495496,3.93087636 C14.4624921,3.95889946 14.942602,3.87546701 2.17233343,11.0162618 C0.981265944,11.6818105 0.235451296,12.8441322 0.0907604388,14.0822436 C1.14568727,14.982804 2.74123087,15.2560291 4.12960384,14.4796621 L15.938337,7.87703804 L27.7470703,14.4796621 Z"
                  id="Path"
                ></Path>
                <Path
                  d="M21.1419403,5.18936821 C21.1419403,7.97257141 18.8117626,10.2284307 15.938337,10.2284307 C13.0642538,10.2284307 10.7347337,7.97257141 10.7347337,5.18936821 C10.7347337,2.40680201 13.0642538,0.150942554 15.938337,0.150942554 C18.8117626,0.150942554 21.1419403,2.40680201 21.1419403,5.18936821 Z"
                  id="Path"
                />
              </G>
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};

ConnectionBadge.defaultProps = {
  size: 145,
};

export default ConnectionBadge;
